import { COLORS } from 'components/layout-components/timenotes-theme'

export const backgroundStyle = {
  backgroundColor: COLORS.primaryPurple,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover'
}
